import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { isNil } from "lodash";
import {
  DocumentIngestionPipeline,
  DocumentIngestionPipelineFilter,
} from "../../generated/graphql";

/**
 * Label for the pipeline that authored a single scanned order result. "Legacy"
 * is the schema-matching pipeline; "Document extraction" is the LLM pipeline.
 */
export const PIPELINE_LABELS: Record<DocumentIngestionPipeline, string> = {
  [DocumentIngestionPipeline.Legacy]: "Legacy",
  [DocumentIngestionPipeline.DocumentExtraction]: "Document extraction",
};

export const PIPELINE_FILTER_LABELS: Record<
  DocumentIngestionPipelineFilter,
  string
> = {
  [DocumentIngestionPipelineFilter.All]: "Both",
  [DocumentIngestionPipelineFilter.Legacy]: "Legacy",
  [DocumentIngestionPipelineFilter.DocumentExtraction]: "Document extraction",
};

const PIPELINE_FILTER_OPTIONS = [
  DocumentIngestionPipelineFilter.All,
  DocumentIngestionPipelineFilter.Legacy,
  DocumentIngestionPipelineFilter.DocumentExtraction,
];

/**
 * Narrows a view to the pipeline that ingested a document. "Legacy" is the
 * schema-matching pipeline, "Document extraction" is the LLM pipeline, and
 * "Both" leaves the view unfiltered.
 *
 * The group is exclusive and always keeps a selection — clicking the active
 * option is a no-op rather than clearing the filter.
 */
const PipelineFilter = ({
  value,
  onChange,
  size = "small",
}: {
  readonly value: DocumentIngestionPipelineFilter;
  readonly onChange: (value: DocumentIngestionPipelineFilter) => void;
  readonly size?: "small" | "medium";
}) => {
  return (
    <ToggleButtonGroup
      exclusive
      size={size}
      value={value}
      onChange={(event, newValue: DocumentIngestionPipelineFilter | null) => {
        if (isNil(newValue)) return;
        onChange(newValue);
      }}
    >
      {PIPELINE_FILTER_OPTIONS.map((option) => (
        <ToggleButton
          key={option}
          value={option}
          sx={{ textTransform: "none", py: 0.25 }}
        >
          {PIPELINE_FILTER_LABELS[option]}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default PipelineFilter;
